import { Section } from '@seek/libs-shared';
import { useTranslations } from '@vocab/react';
import {
  Box,
  Card,
  Column,
  Columns,
  Stack,
  Strong,
  Text,
} from 'braid-design-system';
import type { SalariesTabModel } from '../../../pages/salaries/salariesTabModel';
import { PercentageWheel } from '../../companyReviews/percentageWheel/PercentageWheel';
import translations from './.vocab/index';

interface SalarySatisfactionProps {
  model: Pick<SalariesTabModel, 'salarySatisfactionRating' | 'companyName'>;
}

export const SalarySatisfactionSection = ({
  model,
}: SalarySatisfactionProps) => {
  const { salarySatisfactionRating, companyName } = model;
  const { t } = useTranslations(translations);
  const percentage = salarySatisfactionRating || 0;
  return (
    <Section
      mode={'view'}
      heading={t('Salary satisfaction at companyName', { companyName })}
      padding={'none'}
    >
      <Card>
        <Box padding={['small', 'medium']}>
          <Columns space={'large'} alignY={'center'} collapseBelow="desktop">
            <Column width="content">
              <Box
                paddingY={['none', 'xxsmall']}
                paddingX={['xsmall', 'large']}
              >
                <PercentageWheel
                  model={{ percentage }}
                  showIcon={false}
                  mode="view"
                />
              </Box>
            </Column>
            <Column>
              <Stack
                space="small"
                align={{ mobile: 'center', desktop: 'left' }}
              >
                <Text
                  size="standard"
                  align={{ mobile: 'center', desktop: 'left' }}
                >
                  {t("When companyName employee's were asked...", {
                    companyName,
                  })}
                </Text>
                <Text
                  size="standard"
                  align={{ mobile: 'center', desktop: 'left' }}
                >
                  <Strong>
                    {t(
                      "percentage of employee's rated the salary as high or average",
                      {
                        percentage: percentage.toString(),
                      },
                    )}
                  </Strong>
                </Text>
              </Stack>
            </Column>
          </Columns>
        </Box>
      </Card>
    </Section>
  );
};
